// hooks/useImageClick.ts
import { useEffect, useState } from 'react'

type ClickedImageData = {
  src: string
  rect: DOMRect
} | null

export function useImageClick(containerRef: React.RefObject<HTMLElement>) {
  const [clickedImage, setClickedImage] = useState<ClickedImageData>(null)

  useEffect(() => {
    const handleImageClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement
      if (target.tagName === 'IMG') {
        const img = target as HTMLImageElement
        setClickedImage({ src: img.src, rect: img.getBoundingClientRect() })
      }
    }

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement

      const isInsideImageAssistant = target.closest('.image-assistant')

      if (!isInsideImageAssistant) {
        setClickedImage(null)
      }
    }

    const container = containerRef.current
    container?.addEventListener('click', handleImageClick)
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      container?.removeEventListener('click', handleImageClick)
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [containerRef])

  const clearClickedImage = () => {
    setClickedImage(null)
  }

  return {
    clickedImage,
    clearClickedImage,
  }
}
